import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { SectionDivider } from '../components/SectionDivider';
const reviews = ['https://cdn.magicpatterns.com/uploads/98WDkph6vG3Xde4vL49nRC/Screenshot_2026-07-03_at_14.20.10.png', 'https://cdn.magicpatterns.com/uploads/cRGjD36XKZLK5Q4YA8E1Dw/Screenshot_2026-07-03_at_14.20.01.png', 'https://cdn.magicpatterns.com/uploads/3G3grC6nZqgBCC4BqZm4Uj/Screenshot_2026-07-03_at_14.19.53.png', 'https://cdn.magicpatterns.com/uploads/v4NAFGSFoye2aNXVQtkkW3/Screenshot_2026-07-03_at_14.19.45.png'];
export function Testimoniale() {
  return <div className="w-full" data-id="element-438">
      {/* HERO / INTRO */}
      <section className="bg-navy diagonal-pattern py-24 px-6" data-id="element-439">
        <div className="max-w-3xl mx-auto text-center" data-id="element-440">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-441">
            <div className="text-gold font-label text-xs uppercase tracking-label mb-6" data-id="element-442">
              TESTIMONIALE
            </div>
            <h1 className="text-text-light font-heading text-4xl md:text-6xl font-bold mb-6 leading-tight" data-id="element-443">
              Ce spun oamenii care au lucrat deja{' '}
              <span className="text-gold" data-id="element-444">cu mine</span>
            </h1>
            <p className="text-text-light-secondary font-body text-lg leading-relaxed" data-id="element-445">
              Recomandări reale de la clienți care au trecut prin divorț, partaj
              sau alte situații dificile de familie și au ales să meargă mai
              departe cu claritate și sprijin la fiecare pas.
            </p>
          </motion.div>
        </div>
      </section>

      {/* REVIEWS 2x2 */}
      <section className="bg-cream py-20 px-6" data-id="element-446">
        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8" data-id="element-447">
          {reviews.map((src, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i % 2 * 0.1
        }} className="bg-white rounded-lg p-4 border-l-[3px] border-emerald shadow-[0_4px_20px_rgba(12,35,64,0.08)]" data-id="element-448">
              <img src={src} alt={`Recomandare client ${i + 1}`} className="w-full h-auto rounded" loading="lazy" data-id="element-449" />
            </motion.div>)}
        </div>
      </section>

      <div className="bg-cream" data-id="element-450">
        <SectionDivider data-id="element-451" />
      </div>

      {/* CTA */}
      <section className="bg-navy diagonal-pattern py-20 px-6" data-id="element-452">
        <div className="max-w-3xl mx-auto text-center" data-id="element-453">
          <h2 className="text-text-light font-heading text-3xl md:text-4xl font-bold mb-6" data-id="element-454">
            Ai nevoie de sprijin? Ți-ar plăcea să fiu{' '}
            <span className="text-gold" data-id="element-455">avocatul tău</span> și să te susțin și
            pe tine?
          </h2>
          <p className="text-text-light-secondary font-body text-lg leading-relaxed mb-8" data-id="element-456">
            Rezervă o sesiune de claritate și îți explic exact ce drepturi ai și
            ce poți obține în situația ta. Fără presiune, fără termeni juridici
            grei.
          </p>
          <Link to="/contact" className="inline-block bg-gold text-navy px-8 py-4 rounded font-label text-sm uppercase tracking-label hover:bg-gold/90 transition-colors" data-id="element-457">
            Rezervă Sesiunea de Consultanță
          </Link>
        </div>
      </section>
    </div>;
}